/**
 * Created by Ning Jiang on 2021-06-09.
 */

import {TombstoneRipSymbol} from "./TombstoneRipSymbol";
import {TombstoneRipSymbolState} from "./TombstoneRipSymbolConfig";
import {gsap, TimelineLite} from "gsap";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {TombstoneRip} from "../TombstoneRip";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {TombstoneRipGameMode} from "../gameflow/TombstoneRipGameMode";
import {MultiSprites} from "../../core/animation/MultiSprites";

export class TombstoneSplitSymbol extends TombstoneRipSymbol {

    private _symbolSpine:PIXI.spine.Spine;
    private _wildSpine:PIXI.spine.Spine;

    constructor(symbolName:string, reelId:number, initState:TombstoneRipSymbolState) {
        super(symbolName, reelId, initState);
    }

    protected addSplitBloodAnimation(tl:TimelineLite, oldSymbolSize:number, type:number):void {
        if(this.symbolName === "WXS") {
            return;
        }

        if(oldSymbolSize === 1) {
            this._splitBloodContainer.alpha = 0;
            super.addSplitBloodAnimation(tl, oldSymbolSize, type, false);
        } else {
            super.addSplitBloodAnimation(tl, oldSymbolSize, type);
        }
    }

    protected addSplitSymbolAnimation(tl:TimelineLite, oldSymbolSize:number, type:number) {
        // split into wilds.
        const oldPart = this._parts[0];
        this._parts = [];
        const newPart = new MultiSprites();
        newPart.position.set(this._centerPosition.x, this._centerPosition.y);
        newPart.alpha = 0;
        this.addChild(newPart);
        this._parts.push(newPart);

        const splitSymbolDelay = oldSymbolSize === 1 ? this.splitSymbolDelay : 0;

        if(oldSymbolSize === 1) {
            this.prepareSpine();
            tl.add([
                () => {
                    this._symbolSpine.visible = true;
                    this._symbolSpine.state.setAnimation(0, "splitting", false);
                },
                gsap.to(this, {duration : this._symbolSpine.spineData.findAnimation("splitting").duration})
            ], 0);
            tl.add(() => {this._symbolSpine.state.setAnimation(0, "splitDone", false)});
            if(this.symbolName === "WXS") {
                if(!this._wildSpine) {
                    this._wildSpine = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset(`WXS_Wild`));
                    this._wildSpine.autoUpdate = true;
                    this._wildSpine.position.set(this._centerPosition.x, this._centerPosition.y);
                    this._wildSpine.visible = false;
                }
                tl.add(() => {
                    this.updateLayers();
                    this._wildSpine!.visible = true;
                    new SpineTween(this._wildSpine!, 0, "wildLanding");
                }, splitSymbolDelay);
            }
        }

        tl.add(this.getStateAnimation(TombstoneRipSymbolState.NORMAL,
            {duration : 0, alpha : 1},
            {duration : 0, alpha : 0}
        ), 0);
        tl.add(() => {
            this.removeChild(oldPart);
            oldPart.destroy();
        }, this._splitSplashDelay + this._splitSymbolAnimationDuration + splitSymbolDelay);

        tl.add([
            gsap.to(newPart, {alpha : 1, duration : this._splitSymbolAnimationDuration}),
            gsap.to(this._splitBloodContainer, {alpha : 1, duration : this._splitSymbolAnimationDuration}),
        ], this._splitSplashDelay + splitSymbolDelay);
        if(type === 1) {
            tl.add(this.getPartDaggerSplitAnimation(newPart), this._splitSplashDelay + splitSymbolDelay);
            if(this.symbolName === "WXS") {
                tl.add(this.getPartDaggerSplitAnimation(this._symbolSpine), this._splitSplashDelay + splitSymbolDelay);
            }
        }

        if(this._symbolSpine && this.symbolName === "WRS") {
            tl.add(gsap.to(this._symbolSpine, {
                alpha : 0, duration : this._splitSymbolAnimationDuration, onComplete : () => {
                    this._symbolSpine.visible = false;
                }
            }), this._splitSplashDelay + splitSymbolDelay);
        }
        if(TombstoneRip.model.parsedGameData.mode === GameMode.FREESPIN ||
            TombstoneRip.model.parsedGameData.mode === TombstoneRipGameMode.FREESPIN_SUPER) {
            tl.add(() => TombstoneRip.multiplier.addMultiplier(oldSymbolSize, `${this.symbolName}Splitting on reel${this.reelId}`), this._splitSplashDelay);
        }
    }

    protected updateLayers() {
        super.updateLayers();
        if(this._symbolSpine) {
            this.addChild(this._symbolSpine);
        }
        if(this._wildSpine) {
            this.addChild(this._wildSpine);
        }
        if(this._splitBloodContainer) {
            this.addChild(this._splitBloodContainer);
        }
        if(this._scatterFrame) {
            this.addChild(this._scatterFrame);
        }
        if(this._rip) {
            this.addChild(this._rip);
        }
    }

    public playLanding(init:boolean = false):TimelineLite {
        this.prepareSpine();

        const tl = new TimelineLite();
        tl.add([
            () => {
                this.updateLayers();
                // this._landingSpine.visible = true;
            },
            new SpineTween(this._symbolSpine, 0, "landing")
        ]);
        if(!init && (TombstoneRip.model.parsedGameData.mode === GameMode.FREESPIN ||
            TombstoneRip.model.parsedGameData.mode === TombstoneRipGameMode.FREESPIN_SUPER)) {
            tl.add(() => TombstoneRip.multiplier.addMultiplier(1, `${this.symbolName}Landing on reel${this.reelId}`));
        }
        if(this.symbolName === "WXS") {
            tl.add(() => {new SpineTween(this._symbolSpine, 0, "landed")});
        }
        return tl;
    }

    private prepareSpine():void {
        if(!this._symbolSpine) {
            this._symbolSpine = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset(`${this.symbolName}Animation`));
            this._symbolSpine.autoUpdate = true;
            this._symbolSpine.position.set(this._centerPosition.x, this._centerPosition.y);
            // this._landingSpine.visible = false;
        }
    }
}